<wbo-single-select-control [valueField]="valueField"
                           [labelField]="labelField"
                           [placeholder]="placeholder"
                           [attr.id]="elementId"
                           [(value)]="value"
                           [sourceSearchModel]="model"
                           [data]="data"
                           (onDataLoaded)="onDataLoaded($event)"
                           [objectValue]="objectValue"
                           [readonly]="isReadonly"
                           [allowDirectInput]="allowDirectInput"
                           [isNumeric]="isNumeric"
                           [formControlValidation]="formControl"
                           [labelSearchField]="labelSearchField"
                           [valueSearchField]="valueSearchField"
                           [label]="label"
                           (onSelect)="onSelect.emit($event)"
                           [overrideOpenView]="overrideOpenView"
                           (onOptionOpen)="onOptionOpen($event)"
                           (onClear)="onClear.emit($event)"
                           (onAction)="onAction($event)"
                           (focussed)="onFocus($event)"
                           [allowClearSelectionOption]="allowClearSelectionOption"
                           [clearSelectionOptionLabel]="clearSelectionOptionLabel"
                           [extendedSearchComponent]="extendedSearchComponent"
                           [extendedSearchComponentParams]="extendedSearchComponentParams"
                           [extendedEditComponent]="extendedEditComponent"
                           [extendedEditComponentParams]="extendedEditComponentParams"
                           [hideExtendedSearchOption]="hideExtendedSearchOption"
                           [showAddOption]="showAddOption"
                           [hideAddOption]="hideAddOption"
                           [showOptionOpenOption]="showOptionOpenOption"
                           [hideOptionOpenOption]="hideOptionOpenOption"
                           [actions]="actions">
</wbo-single-select-control>
